import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { environment } from '../environments/environment';

import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import {
  msalInstanceFactory,
  msalGuardConfigFactory,
  msalInterceptorConfigFactory,
} from './api/auth-service/msal-config';

import {
  API_BASE_URL as CONTROLTOWER_API_BASE_URL,
  ControlTowerServiceClient,
} from './api/controltower-service/auto-generated-client';

import {
  API_METADATA_BASE_URL,
  MetadataServiceClient,
} from './api/metadata-service/auto-generated-client';

import { MetadataConfigService } from './services/metadata-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),

    // MSAL Angular providers
    { provide: MSAL_INSTANCE, useFactory: msalInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: msalGuardConfigFactory },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: msalInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },

    // API base URL from environment
    { provide: CONTROLTOWER_API_BASE_URL, useValue: environment.apiUrl },
    { provide: API_METADATA_BASE_URL, useValue: environment.metadataApiUrl },

    // Auto-generated service clients
    ControlTowerServiceClient,
    MetadataServiceClient,

    // Caches config variables fetched via MetadataServiceClient into a shared signal
    MetadataConfigService,
  ],
};
